export default __webpack_public_path__ + "static/Home-992-9a14c0b83957dee0b334a863cf693d00.webp";